import { render, staticRenderFns } from "./BotaoAcao.vue?vue&type=template&id=a75f7b2c&scoped=true&"
import script from "./BotaoAcao.vue?vue&type=script&lang=js&"
export * from "./BotaoAcao.vue?vue&type=script&lang=js&"
import style0 from "./BotaoAcao.vue?vue&type=style&index=0&id=a75f7b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75f7b2c",
  null
  
)

export default component.exports